import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { useHasStardustConsent } from "Hooks/useHasStardustConsent";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

/**
 * Whether the current user's loyalty points (header counter, rewards popup, chat header) are shown.
 * Hunters — Hunter and Hunter+ alike, both earn Valor — always see them. Customers see Stardust
 * only once they consented (ZS-1624, legal 2026-09-29): without the consent the program is not
 * theirs to look at — the Stardust page asks for it first.
 */
export const useIsLoyaltyPointsVisible = (): boolean => {
  const role = useCurrentUserRole();
  const isHunter = useIsCurrentUserHunter();
  const { hasStardustConsent } = useHasStardustConsent();

  if (isHunter) {
    return true;
  }

  return role === AccessRoleCodes.Customer && hasStardustConsent === true;
};
